import snakeCase from "lodash/snakeCase";
import Router from "next/router";

export const checkValue = (value: string): string | undefined =>
  value ? value : undefined;

export const fetchQuery = (camelCaseQueryName: string): string => {
  return (Router.query[snakeCase(camelCaseQueryName)] || "")
    .toString()
    .toLowerCase();
};
